import { InjectionToken, Provider } from '@angular/core';
import { SettingsRepository } from '../settings.repository';
import { SettingsService } from '../settings.service';

export const HTTP_SETTINGS_SERVICE = new InjectionToken<SettingsRepository>('SettingsRepository');

export const SETTINGS_API_PROVIDER: Provider = {
    provide: HTTP_SETTINGS_SERVICE,
    useClass: SettingsService,
};
